import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// -------------------------------------------------PLP List Card --------------------------------------
// style of PLP List View top level iterating items goes here
cardContainerStyles.cardDivider = {
    css: css`
        width: 100%;
        margin-top: 20px;
        padding: 16px 7px 20px 20px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
        &:last-child {
            margin-bottom: 40px;
        }
    `,
};

cardContainerStyles.gridItem = {
    width: 12,
};
// end of PLP List View top level iterating items style

// -------------------------------------------------PLP Grid Card -------------------------------------
// style of PLP Grid View top level iterating items goes here
cardContainerMultiColumnStyles.gridItem = {
    css: css`
        padding-top: 20px;
        padding-left: 10px;
        padding-right: 10px;

        width: calc(100% / 3);
        flex-basis: calc(100% / 3);
        max-width: calc(100% / 3);

        @media only screen and (max-width: 1320px) and (min-width: 1025px) {
            width: calc(100% / 2);
            flex-basis: calc(100% / 2);
            max-width: calc(100% / 2);
        }

        @media only screen and (max-width: 1023px) {
            width: calc(100% / 2);
            flex-basis: calc(100% / 2);
            max-width: calc(100% / 2);
        }

        @media only screen and (max-width: 700px) {
            width: 100%;
            flex-basis: 100%;
            max-width: 100%;
            padding-left: 0;
            padding-right: 0;
        }
    `,
};
cardContainerMultiColumnStyles.cardDivider = {
    css: css`
        padding: 20px;
        height: 100%;
        width: 100%;
        background-color: #ffffff;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
    `,
};
// end of PLP Grid View top level iterating items style
